import React from 'react';
import Button from '../../components/buttons/Button';
import Btvoltar from '../../components/buttons/Btvoltar';
import TextInput from '../../components/form/TextInput';
import './styles-form-pagamento.css';
import ButtonPlano from './ButtonPlano';
import AMEX from '../../img/AMEX.svg';
import BILLET from '../../img/BILLET.svg';
import DINERS from '../../img/DINERS.svg';
import ELO from '../../img/ELO.svg';
import HIPER from '../../img/HIPER.svg';
import HIPERCARD from '../../img/HIPERCARD.svg';
import MASTER_CARD from '../../img/MASTER_CARD.svg';
import VISA from '../../img/VISA.svg';
import STRINGS from './../../data/language/language';

export default class PagamentoBoleto extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      nome_cartao: '',
      cpf_cnpj: '',
      cartao: '',
      data_expiracao: '',
      cvc: '',
      tipo_pagamento: 'cartao',
      strings:STRINGS[window.LANGUAGE],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {

    event.preventDefault();
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

    this.props.handleInputChange(event);
  }
  render(){
    const strings = this.state.strings;
    return(
      <div className='box-boleto'>
        <div className='box-boleto-fique-atento'>Fique atento(a) aos detalhes:</div>
        <ul>
          <li>Boleto (somente à vista)</li>
<li>Pagamentos com Boleto Bancário levam até <strong>3 dias úteis</strong> para serem compensados e então terem os produtos liberados</li>
<li>Fique atento(a) ao vencimento do boleto. Você pode pagar o boleto em qualquer banco ou casa lotérica até o dia do vencimento</li>
<li>Depois do pagamento, fique atento ao seu e-mail para receber os dados de acesso ao produto (verifique também a caixa de SPAM)</li>
        </ul>
        <br />
        <p className='txt-preencha-field-boleto'>Preencha os dados abaixo para gerar seu boleto</p>
        <br />
        <div className='wrapper-pagamento'>
          <div className="pure-g">
            <div className="pure-u-1-2">
              <TextInput
                value={this.state.telefone}
                inputMask={{
                  name:'telefone',
                  placeholder: strings.digiteTel,
                  mask: "(99) 99999-9999",
                  maskChar: "_"
                }}
                onChange={this.handleInputChange}
                name="telefone"
                title={`${strings.txtTel}*`}
                placeholder={strings.digiteTel}>
              </TextInput>
            </div>
            <div className="pure-u-1-2">
              <TextInput
                value={this.state.cpf_cnpj}
                inputMask={{
                  name:'cpf_cnpj',
                  placeholder: strings.digiteCpf,
                  mask: "999.999.999-99",
                  maskChar: "_"
                }}
                onChange={this.handleInputChange}
                name="cpf_cnpj"
                title={`${strings.txtCpf}*`}
                placeholder={strings.digiteCpf}>
              </TextInput>
            </div>
          </div>
        </div>
<br /><br />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/PagamentoBoleto.js